<template>
  <section
    :class="[
      'base-section',
      `bg-${backgroundStyle}`,
      { 'with-spacing': withSpacing }
    ]"
    :style="customStyles"
  >
    <div class="container">
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue'

interface Props {
  backgroundStyle?: 'light' | 'dark' | 'custom'
  withSpacing?: boolean
  customStyles?: Record<string, string>
}

withDefaults(defineProps<Props>(), {
  backgroundStyle: 'light',
  withSpacing: true,
  customStyles: () => ({})
})
</script>

<style scoped>
.base-section {
  position: relative;
  z-index: 50;
}

.base-section.with-spacing {
  padding: 8rem 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.bg-light {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.bg-dark {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: white;
  z-index: 100;
  margin-top: -2px;
}

@media (max-width: 768px) {
  .base-section.with-spacing {
    padding: 6rem 1rem;
  }
}
</style>
